import React from 'react';
import {useHistory} from 'react-router-dom';
import {Grid, List, ListItem, Button} from "@mui/material";
import Typography from "@mui/material/Typography";
import ItineraryActivityDate from "../../Booking/Summary/ItineraryActivityDate";
// import PrimaryButton from "../../Common/PrimaryButton";
import {styled} from "@mui/styles";
import {getItinerary} from "../../../utils/utils";
import { useEffect } from 'react';

const ItineraryList = styled(List)(({theme}) => ({
    width: '100%',
    paddingBottom: 0,
    paddingTop: 0,
    marginTop: '20px'
}));
const GuestItinerary = ({booking: {booking: {trip}, transactions, activities, payments}, guests}) => {
	const history = useHistory();
    const itinerary = getItinerary({
        extra: Object.values(activities.Extras),
        complimentary: Object.values(activities.Complimentary)
    }, {
        extra: transactions.extra,
        complimentary: transactions.activities
    }, trip);

	const updateGuestExtraOrder = (guestId) => {
		history.push(`/booking/guest/${guestId}/extra-order`);
    };

    return (
        <div style={{marginTop: '50px'}}>
            <Grid container>
                <Grid item xs={12} md={9}>
                    <Typography variant={"h3"}>Itinerary</Typography>
					
                </Grid>
                <Grid item xs={12} md={3}>
					{
						Object.values(payments).some(obj => obj.paid === true) && <Button
							color={'primary'}
							variant={'contained'}
							fullWidth
							onClick={() => updateGuestExtraOrder(guests[0].guestFk)}
						>
							Book extra activities
						</Button>
					}
                </Grid>
            </Grid>
            <ItineraryList>
                {Object.keys(itinerary).map(date => (
                    <ItineraryActivityDate key={date} date={date} activities={itinerary[date]} guestForm/>
                ))}
            </ItineraryList>
        </div>
    );
};

export default GuestItinerary;